import React, { CSSProperties, FC, HTMLAttributes } from 'react'

import cn from 'classnames'

import classes from './responsive.module.scss'

export const HideOnMobile: FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...rest
}) => (
  <div className={cn(classes.hideOnMobile, className)} {...rest}>
    {children}
  </div>
)

interface HideOnTabletProps extends HTMLAttributes<HTMLDivElement> {
  display?: string
}

export const HideOnTablet: FC<HideOnTabletProps> = ({
  display,
  className,
  style,
  children,
  ...rest
}) => (
  <div
    className={cn(classes.hideOnTablet, className)}
    style={{ ...style, '--hot-display': display || 'inherit' } as CSSProperties}
    {...rest}
  >
    {children}
  </div>
)

export const HideTabletUpwards: FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...rest
}) => (
  <div className={cn(classes.hideTabletUpwards, className)} {...rest}>
    {children}
  </div>
)

export const HideSmallDesktopUpwards: FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...rest
}) => (
  <div className={cn(classes.hideSmallDesktopUpwards, className)} {...rest}>
    {children}
  </div>
)
